import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import colours from './Colours';
import Icon from './Icons/Icon';
import { P2Bold, P3, P3Bold } from './Text';
import Button from './Button';
import { LoadingIcon } from '../Loading_Icon';

const FileUploadCard = (props) => {
    const [dragging, setDragging] = useState(false);
    const [dragCounter, setDragCounter] = useState(0);
    const dropRef = props.dropRef;
    const inputRef = props.inputRef;

    useEffect(()=> {
        if (dropRef) {
            let div = dropRef.current;
            if (div) {
                div.addEventListener('dragenter', handleDragIn);
                div.addEventListener('dragleave', handleDragOut);
                div.addEventListener('dragover', handleDrag);
                div.addEventListener('drop', handleDrop);
            }
    
            return function cleanup() {
                if (div) {
                    div.removeEventListener('dragenter', handleDragIn);
                    div.removeEventListener('dragleave', handleDragOut);
                    div.removeEventListener('dragover', handleDrag);
                    div.removeEventListener('drop', handleDrop);
    
                }
            }
        }
    }, [])

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }
    
    const handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragCounter(dragCounter + 1);
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setDragging(true);
        }
    }
    
    const handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragCounter(dragCounter - 1);
        if (dragCounter > 0) return;
        setDragging(false);
    }

    const handleDrop = (e) => {
        let files = e.dataTransfer.files;
        e.preventDefault();
        e.stopPropagation();
        setDragCounter(dragCounter - 1);
        if (dragCounter > 0) return;
        setDragging(false);
        props.handleUpload(files);
    }

    const handleUpload = (e) => {
        if (e.current) {
            let files = e.current.files;
            props.handleUpload(files);
        } else if (e.target) {
            let files = e.target.files;
            props.handleUpload(files);
        }
    }

    const activeIconStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}

    return (
        <>
            {   props.loading ?
                    <div className="overlay_header_bordered" style={{display: 'flex', flex: 1, flexDirection: 'row', marginBottom: 16, textOverflow: 'ellipsis', overflowWrap: 'break-word'}}>
                        <div style={{height: 76, minWidth: 76, maxWidth: props.squareImg ? 76 : 136, borderRadius: 8, marginRight: 8, overflow: 'hidden'}}>
                            <LoadingIcon/>
                        </div>
                        <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                            <div style={{display: 'flex', flex: 1, flexDirection: 'column', width: '100%'}}>
                                <P3Bold>
                                    <div style={{wordBreak: 'break-word'}}>
                                        Uploading...
                                    </div>
                                </P3Bold>
                            </div>
                            {props.replaceClick ? 
                                <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
                                    <Button disabled label="Replace" small leading_ic="Refresh" secondary onClick={props.replaceClick}/>
                                </div> 
                            : null}
                        </div>
                    </div>
                : props.imageSrc ?
                <div className="overlay_header_bordered" style={{display: 'flex', flex: 1, flexDirection: 'row', marginBottom: 16, textOverflow: 'ellipsis', overflowWrap: 'break-word'}}>
                    <div style={{height: 76, minWidth: 76, maxWidth: props.squareImg ? 76 : 136, borderRadius: 8, marginRight: 8, overflow: 'hidden'}}>
                        {props.imageSrc.includes('.pdf') || props.imageSrc.includes('.doc') || props.imageSrc.includes('.docx') ? 
                            <iframe src={(props.imageSrc.includes('.doc') || props.imageSrc.includes('.docx') ? 'https://view.officeapps.live.com/op/embed.aspx?src=' : '') + props.imageSrc} style={{width: '100%', height: '100%', border: 'none'}}></iframe>
                            : <img src={props.imageSrc}/>
                        }
                    </div>
                    <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                        <div style={{display: 'flex', flex: 1, flexDirection: 'column', width: '100%'}}>
                            <P3Bold>
                                <div style={{wordBreak: 'break-word'}}>
                                    {props.imageName || ''}
                                </div>
                            </P3Bold>
                        </div>
                        {props.replaceClick ? 
                            <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
                                <Button label="Replace" small leading_ic="Refresh" secondary onClick={props.replaceClick}/>
                            </div> 
                        : null}
                    </div>
                </div>
            : 
                <div className={`dropbox ${dragging ? "active" : "inactive"}`} style={{display: 'inline-flex', position: 'relative', width: '100%', justifyContent: 'center', marginBottom: 5}} ref={dropRef}>
                    <label style={{width: '100%', display: 'flex', flexDirection: 'column', maxHeight: '120px', padding: '24px 16px', flex: 1, justifyContent: 'center', alignItems: 'center', cursor: 'pointer', pointerEvents: 'all'}} onClick={()=>inputRef.current.click()}>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Icon name="Attach" size={24} style={activeIconStyle}/>
                            <P2Bold style={{color: colours.primary.grey01, lineHeight: '24px', marginLeft: 10}}>{i18n.t(props.uploadText)}</P2Bold>
                        </div>
                        <>
                            <P3 style={{color: colours.primary.grey02, marginTop: 4}}>{'Supports: ' + props.accept}</P3>
                            <P3 style={{color: colours.primary.grey02, marginTop: 4}}>{i18n.t('Max file size: 10MB')}</P3>
                        </>
                    </label>
                </div>
            }
            <input type="file" style={{display: 'none'}} onChange={handleUpload} accept={props.accept ? props.accept : "image/png, image/jpeg"} multiple={props.multiple} ref={inputRef}/>
        </>
    )
};

FileUploadCard.defaultProps = {
    imageSrc: '',
    accept: '',
    imageName: '',
    uploadText: 'Add File or Drop Here',
    replaceClick: null,
    handleUpload: null,
    loading: false,
    multiple: false,
    inputRef: null,
    dropRef: null,
}

FileUploadCard.propTypes = {
    imageSrc: PropTypes.string,
    accept: PropTypes.string,
    imageName: PropTypes.string,
    uploadText: PropTypes.string,
    replaceClick: PropTypes.func,
    handleUpload: PropTypes.func,
    loading: PropTypes.bool,
    multiple: PropTypes.bool,
    inputRef: PropTypes.object,
    dropRef: PropTypes.object,
}

export default FileUploadCard;